// extracted by mini-css-extract-plugin
export default {"input":"Q8-z","button":"R8-z","selected":"S8-z","unavailable":"T8-z","oos":"U8-z","image":"V8-z","paperCutDisabledOverlay":"W8-z"};